import { css, Global } from '@emotion/react';
import { theme } from '@myme/utils';

export const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        html {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          height: 100%;
          width: 100%;
        }
        body {
          max-width: 100vw;
          margin: 0;
          box-sizing: border-box;
          font-family: PoppinsLight, PoppinsBold, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
          overflow-x: hidden;
          letter-spacing: 0.5px;
          background-color: ${theme.colors.backgroundPrimary};
        }
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          transition: background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s;
          transition-delay: background-color 5000s, color 5000s;
        }
      `}
    />
  );
};
